<template>
  <Modal :title="modalTitle" @backdrop-click="$emit('close')">
    <template slot="body">
      <label>Стоимость</label>
      <div>
        <input
          maxlength="50"
          v-model.trim="price"
          class="form-control"
          :placeholder="product.price || 'Стоимость у поставщика'"
        />
      </div>
    </template>
    <template slot="footer">
      <div class="modal__buttons">
        <button
          type="button"
          :disabled="price.length === 0"
          class="modal-default-button btn btn-success"
          @click="setProduct"
        >
          Подтвердить
        </button>
        <button
          type="button"
          class="modal-default-button btn btn-danger"
          @click="$emit('close')"
        >
          Отмена
        </button>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/_shared/components/ui/Modal";
export default {
  components: {
    Modal,
  },
  emits: [
    "close",
    "on-add",
    "on-edit",
  ],
  props: {
    product: {
      type: Object,
      default() {
        return {
          price: null,
        };
      },
    },
    actionType: {
      type: String,
      default: 'add',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      price: "",
    };
  },
  methods: {
    async setProduct() {
      const { name, vendor_code, type, id, entity } = this.product;
      const body = {
        id, name, vendor_code, type,
        price: this.price,
        entityKey: this.product.entityKey || `${entity}_id`,
        provider_product_id: this.product.provider_product_id || null,
      };
      this.$emit(`on-${this.actionType}`, body);
      this.$emit('close');
    },
  },
  computed: {
    modalTitle() {
      const { name } = this.product;
      const firstWord = this.actionType === 'add' ? 'Добавление' : 'Редактирование';
      const title = `${firstWord} продукта "${name}"`;
      return title;
    },
    providerId() {
      const { fullPath } = this.$router.currentRoute;
      const slug = fullPath.split("/").pop();
      return slug;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/business/widgets/provider-products/PriceModal.vue